import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Request interceptor — attach access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor — handle 401, auto-refresh
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && error.response?.data?.code === 'TOKEN_EXPIRED' && !original._retry) {
      original._retry = true;
      try {
        const { data } = await axios.post(`${API_URL}/auth/refresh`, {}, { withCredentials: true });
        localStorage.setItem('accessToken', data.accessToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(original);
      } catch {
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/* EXP8 */ // global network reliability for whole PMS
(function (A) {
  if (!A || !A.interceptors || A.__exp8) return;
  A.__exp8 = true;
  if (!A.defaults.timeout) A.defaults.timeout = 30000;
  const isFD = (d) => typeof FormData !== 'undefined' && d instanceof FormData;
  A.interceptors.request.use((cfg) => { if (isFD(cfg.data)) cfg.timeout = Math.max(cfg.timeout || 0, 180000); return cfg; });
  A.interceptors.response.use((r) => r, (err) => {
    const cfg = err && err.config;
    if (cfg && !err.response && String(cfg.method).toLowerCase() === 'get' && !cfg.__retried && !err.__CANCEL__) {
      cfg.__retried = true;
      return new Promise((ok) => setTimeout(ok, 800)).then(() => A.request(cfg));
    }
    if (err && !err.response && !err.__CANCEL__) err.response = { status: 0, data: { error: err.code === 'ECONNABORTED' ? 'Server took too long — please try again' : 'No internet / server not reachable — please try again' } };
    return Promise.reject(err);
  });
  const inflight = new Map();
  ['post', 'put', 'patch', 'delete'].forEach((m) => {
    const orig = A[m].bind(A);
    A[m] = (url, a, b) => {
      const data = m === 'delete' ? undefined : a;
      if (isFD(data)) return orig(url, a, b);
      let key;
      try { key = m + ' ' + url + ' ' + (data === undefined ? '' : JSON.stringify(data)); } catch (e) { return orig(url, a, b); }
      if (inflight.has(key)) return inflight.get(key); // double-tap: reuse the same request
      const p = orig(url, a, b).finally(() => inflight.delete(key));
      inflight.set(key, p);
      return p;
    };
  });
})(api);

export default api;
